import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';
import { AuthGuard } from 'src/app/core/auth-guard/auth.guard';
import { RolesGuard } from 'src/app/core/roles/roles.guard';
import { UserGuard } from 'src/app/core/user-guard/user-guard.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'B2B',
    loadChildren: () =>
      import('../../main/b2-b/b2-b.module').then(m => m.B2BModule)
  },
  {
    path: 'esign',
    loadChildren: () =>
      import('../../main/e-sign/e-sign.module').then(m => m.ESignModule)
  },
  {
    path: 'dispatch-sheet',
    loadChildren: () =>
      import('../../main/dispatch-sheet/dispatch-sheet.module').then(
        m => m.DispatchSheetModule
      )
  },
  {
    path: 'mercury',
    loadChildren: () =>
      import('../../main/mercury-credit-card/mercury-credit-card.module').then(
        m => m.MercuryCreditCardModule
      )
  },
  {
    path: 'main',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        data: {
          action: 'redirect',
          rules: [
            { role: 'fronter', view: 'fronter', pathModule: 'dashboard' },
            { role: 'sales_rep', view: 'sales_rep', pathModule: 'dashboard' },
            {
              role: 'sales_manager',
              view: 'sales_rep',
              pathModule: 'dashboard'
            },
            { role: 'super_admin', view: '', pathModule: 'dashboard' },
            { role: 'dispatcher', view: 'dispatcher', pathModule: 'dashboard' },
            { role: 'dispatcher_manager', view: 'dispatcher', pathModule: 'dashboard' },
            { role: 'track_trace', view: '', pathModule: 'orders' },
            { role: 'account_payable', view: '', pathModule: 'orders' },
            { role: 'account_receivable', view: '', pathModule: 'orders' },
            { role: 'carrier_relations', view: '', pathModule: 'orders' },
            { role: 'data_entry', view: '', pathModule: 'orders' },
            { role: 'quality_assurance', view: '', pathModule: 'orders' },
            { role: 'carrier_sales', view: '', pathModule: 'orders' }
          ]
        },
        canActivate: [RolesGuard, UserGuard],
        redirectTo: '',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../../main/dashboard/dashboard.module').then(
            m => m.DashboardModule
          ),
        canActivate: [UserGuard]
      },
      {
        path: 'quotes',
        loadChildren: () =>
          import('../../main/quotes/quotes.module').then(m => m.QuotesModule),
        canActivate: [RolesGuard]
        // data: {
        //   roles: ['sales_rep', 'sales_manager', 'super_admin']
        // }
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('../../main/orders/orders.module').then(m => m.OrdersModule),
        canActivate: [RolesGuard]
        // data: {
        //   roles: [
        //     'dispatcher',
        //     'track_trace',
        //     'sales_rep',
        //     'sales_manager',
        //     'account_receivable',
        //     'account_payable',
        //     'carrier_relations',
        //     'super_admin',
        //     'data_entry',
        //     'quality_assurance'
        //   ]
        // }
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('../../main/orders/orders.module').then(m => m.OrdersModule),
        canActivate: [RolesGuard],
        data: {
          // roles: ['super_admin'],
          roleLoaded: 'account_payable'
        }
      },
      {
        path: 'order-management',
        loadChildren: () =>
          import('../../main/orders-management/orders-management.module').then(
            m => m.OrdersManagementModule
          ),
        canActivate: [RolesGuard]
        // data: {
        //   roles: [
        //     'sales_rep',
        //     'sales_manager',
        //     'super_admin',
        //     'data_entry',
        //     'dispatcher',
        //     'quality_assurance',
        //     'carrier_relations',
        //     'account_payable'
        //   ]
        // }
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('../../main/settings/settings.module').then(
            m => m.SettingsModule
          )
      },
      {
        path: 'leads',
        loadChildren: () =>
          import('../../main/leads/leads.module').then(m => m.LeadsModule),
        canActivate: [RolesGuard]
        // data: {
        //   roles: ['fronter', 'sales_rep', 'sales_manager', 'super_admin']
        // }
      },
      {
        path: 'companies',
        loadChildren: () =>
          import('../../main/companies/companies.module').then(
            m => m.CompaniesModule
          ),
        canActivate: [RolesGuard]
        // data: {
        //   roles: [
        //     'sales_rep',
        //     'sales_manager',
        //     'super_admin',
        //     'account_receivable'
        //   ]
        // }
      },
      {
        path: 'carriers',
        loadChildren: () =>
          import('../../main/carriers/carriers.module').then(
            m => m.CarriersModule
          ),
        canActivate: [RolesGuard]
        // data: {
        //   roles: [
        //     'dispatcher',
        //     'account_payable',
        //     'sales_rep',
        //     'sales_manager',
        //     'super_admin',
        //     'carrier_sales'
        //   ]
        // }
      },
      {
        path: 'users',
        loadChildren: () =>
          import('../../main/users/users.module').then(m => m.UsersModule),
        canActivate: [RolesGuard]
        // data: { roles: ['super_admin'] }
      },
      {
        path: 'tiers',
        loadChildren: () =>
          import('../../main/tiers/tiers.module').then(m => m.TiersModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule {}
